import { getLocaleCookie } from '@/shared/lib/locale-cookie';
import { isValidLocale } from '@/shared/constants/locales';
import { updateUserLocale } from '../api/update-locale';

/**
 * Reconcile the locale picked by the user on the login / register screen
 * (stored in the NEXT_LOCALE cookie) with the locale saved in their profile
 * on the server. The guest choice wins — otherwise the UI would visibly flip
 * to the server-stored locale right after a successful sign-in.
 *
 * Fire-and-forget: failures are logged but never interrupt the auth flow.
 */
export async function syncGuestLocaleAfterLogin(
  userLocale: string | undefined
): Promise<void> {
  const cookieLocale = getLocaleCookie();

  if (!cookieLocale || !isValidLocale(cookieLocale)) {
    return;
  }

  if (cookieLocale === userLocale) {
    return;
  }

  try {
    await updateUserLocale(cookieLocale);
  } catch (error) {
    console.error('Failed to sync guest locale to API:', error);
  }
}
